import { EchoConversation } from "@bgea-js/form-templates";
import "../../../../src/content/sms-what-is-heaven-like/heaven.scss";
import * as React from 'react';
export default {
  EchoConversation,
  React
};